import React from 'react';

class CurrentTasksPage extends React.Component {
  render() {
    return(
        <div>
            <h1>This page is outdated.</h1>
            <h2><a href="https://skip.app">Please update your app</a></h2>
        </div>
    )
  }
}

export {CurrentTasksPage};



// WEBPACK FOOTER //
// ./src/street-team/CurrentTasksPage.js